import { isReturns } from '@sav-common/helpers'

import { PRODUCT_RETURN_STATES } from '../../../constants'

export default {
  namespaced: true,

  state() {
    return {}
  },
  actions: {
    // Update the cache after we archived a product return
    async archived({ dispatch }, { context, customerRequestId }) {
      // First, we update the status of the product return.
      dispatch(
        'customerRequestDiscussion/information/update',
        {
          customerRequestId,
          updates: {
            productReturnState: PRODUCT_RETURN_STATES.returnBackDelivered,
          },
        },
        { root: true },
      )

      // Then if we are in the product return context, we can remove the product
      // return from the list as it's not a pending product return anymore.
      if (isReturns(context)) {
        dispatch(
          'customerRequestPlatform/conversations/remove',
          { customerRequestId },
          { root: true },
        )
      }
    },
  },
}
